import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from 'api/client';

export type EngagementCategory =
    | 'HIGHLY_ENGAGED'
    | 'ENGAGED'
    | 'MODERATE'
    | 'LOW_ENGAGEMENT'
    | 'AT_RISK';

export interface EngagementScoreBreakdownItem {
    rule: string;
    value: string;
}

export interface EngagementScoreResponse {
    engagement_score: number;
    engagement_category: EngagementCategory;
    summary: string;
    score_breakdown: EngagementScoreBreakdownItem[];
    recommended_actions: string[];
}

export function get(
    applicationId: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<EngagementScoreResponse>> {
    return client.get<EngagementScoreResponse>(
        `/application/${applicationId}/engagement-score`,
        customConfig
    );
}
